import React from "react";
import {executeQuery} from "../../requests/executeQuery";
import filter from "../../filter";
import {getData} from "../../requests/CRUD";
import {formatPropertyName, sortArray} from "../../utils";
import Icon from "../Icon";
import svgSort from '../../svgs/sort.svg';
import svgSortAsc from '../../svgs/sort-asc.svg';
import svgSortDesc from '../../svgs/sort-desc.svg';
import {PROPERTIES} from "../../consts/tables";
import { GET_PROPERTIES, GET_PROPERTY_DATA, GET_PROPERTY_WEBSITE_USERS } from "../Graphql/Queries/propertiesQuery";
import { ApolloConsumer } from "@apollo/client";
import { fetchData } from "../Service/graphQlService";

const cloneDeep = require('lodash.clonedeep');
const findIndex = require('lodash.findindex');

export default class PropertyStatistics extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
          columns: [
            {
              label: "Type",
              key: "TYPE",
              sort: "default",
            },
            {
              label: "First Name",
              key: "first_name",
            },
            {
              label: "Last Name",
              key: "last_name",
            },
            {
              label: "Company",
              key: "company_name",
            },
            {
              label: "Phone",
              key: "phone",
            },
            {
              label: "Email",
              key: "email",
            },
            {
              label: "Downloads",
              key: "DOWNLOADS",
              style: "center", 
              sort: "default",
              width:"160px"
            },
            {
              label: "Last Downloaded On",
              key: "LAST_DOWNLOADED",
              style: "center",
              sort: "default",
              className: "last_download",
            },
          ],
          data: [],
          original: [],
          loading: true,
          propertyInfo: null,
        };
        this.client = null;
        this.sortTable = this.sortTable.bind(this);
        this.sortData = this.sortData.bind(this);
        
    }

    componentDidMount() {
        if(this.client){
        this.fetch(this.props.params.id);
        }
    }

    fetch(id) {
        let token = localStorage.getItem('authToken');
        this.setState({loading: true});
        const options = filter({PROPERTY_ID: id}, 'statistics');
        const propertyOptions = {
            limit: {
                count: 1,
                offset: 0,
            },
            column: [
                'NAME',
                'CITY',
                'STATE',
            ],
            filter: [{
                code: 'ARCIMEDES_ROW_ID',
                text: id,
                type: 'exact',
            }],
        };

        // Promise.all([
        //     getData({tableCode: PROPERTIES, options: propertyOptions}),
        //     executeQuery({queryName: 'PROPERTY_WEBSITE_USERS', options}),

        // ]).then(res => {
            Promise.all([
                // this.client.query({ query: GET_PROPERTY_DATA, variables: { arcimedesRowId: id },
                //     fetchPolicy: "no-cache",
                //     context: {
                //       headers: {
                //         authorization: `Bearer ${token}`,
                //       },
                //     } }),
                    fetchData(GET_PROPERTY_DATA,{ arcimedesRowId: id }),
                    // this.client.query({ query: GET_PROPERTY_WEBSITE_USERS, variables: { propertyId: id },
                    //     fetchPolicy: "no-cache",
                    //     context: {
                    //       headers: {
                    //         authorization: `Bearer ${token}`,
                    //       },
                    //     } }),
                        fetchData(GET_PROPERTY_WEBSITE_USERS,{ propertyId: id }),
            ]).then(res => {
           // if (res && res[0] && res[0].success && Array.isArray(res[0].data) &&
           if (res && res[0] && res[0].data.getpropertyQuery &&
                res[1] && res[1].data && Array.isArray(res[1].data.getWebsiteUser)) {
                const property = res[0].data.getpropertyQuery ;
                const propertyName = property && property.name ? property.name : '';
                const propertyCity = property && property.city ? property.city : '';
                const propertyState = property && property.state ? property.state : '';
                const propertyInfo = formatPropertyName(propertyName, propertyCity, propertyState);
                const columns = this.state.columns;
                let data = PropertyStatistics.buildTable(columns, res[1].data.getWebsiteUser, id);
                this.setState({
                    data,
                    original: cloneDeep(data),
                    propertyInfo,
                });
            }
            this.setState({loading: false});
        });
    }
    sortData(array, key, desc = false) {
        const copyArray = cloneDeep(array);
        const withValue = [];
        const withoutValue = [];
    
        copyArray.forEach(item => {
            if (item.LAST_DOWNLOADED.trim() === "") {
                withoutValue.push(item);
            } else {
                withValue.push(item);
            }
        });
        const separatedArray = [...withValue, ...withoutValue];
       
        if (key) {
            if (key === "LAST_DOWNLOADED") {
                separatedArray.sort((a, b) => {
                        const dateA = new Date(a.LAST_DOWNLOADED);
                        const dateB = new Date(b.LAST_DOWNLOADED);
                        return !desc ? dateA - dateB : dateB - dateA;
                });
            }
            else {
                if (desc) {
                    separatedArray.sort((a, b) => (a[key] > b[key]) ? -1 : 1);
                } else {
                    separatedArray.sort((a, b) => (a[key] < b[key]) ? -1 : 1);
                }
            }
    
        } else {
            if (desc) {
                separatedArray.sort((a, b) => (a > b) ? -1 : 1);
            } else {
                separatedArray.sort((a, b) => (a < b) ? -1 : 1);
            }
        }
        return separatedArray;
    }

    sortTable(key) {
        let {data, columns} = {...this.state};
        const index = findIndex(columns, {key});

        if (columns[index] && columns[index].sort) {
            // old direction = 'default' (desc by ARC_ROW_ID) => new direction = 'asc'
            // old direction = 'asc' => new direction = 'desc'
            // old direction = 'desc' => new direction = 'default'
            columns[index].sort = columns[index].sort === 'asc' ? 'desc' : (columns[index].sort === 'desc' ? 'default' : 'asc');
            if (columns[index].sort === 'default') {
                data = this.state.original;
            } else {
                const isDesc = columns[index].sort !== 'asc';
                //data = sortArray(this.state.original, key, isDesc);
                data = this.sortData(this.state.original, key, isDesc);
                columns.map((column, colIndex) => {
                    if(column.sort && column.sort !== 'default' && index !== colIndex) {
                        column.sort = 'default';
                    }
                });
            }
        }

        this.setState({data, columns});
    }

    static buildTable(columns, res, id) {
        const data = [];
        res.map((row, index) => {
            data[index] = {};
            columns.map(column => {
                if (column.key === 'TYPE') {
                    data[index][column.key] = row.is_principal === 'y' ? 'Principal' : row.is_broker === 'y' ? 'Broker' : '';
                    return;
                }
                if (column.key === 'DOWNLOADS') {
                    
                    if (row.packages_id) {
                        const packageIds = row.packages_id.split(',');
                        data[index][column.key] = packageIds.reduce((accumulator, currentValue) => accumulator + (currentValue.split('|')[0] === id ? 1 : 0), 0);
                    } else {
                        data[index][column.key] = '';
                    }
                    return;
                } else if(column.key === "LAST_DOWNLOADED"){
                    if (row.packages_id) {
                        const packageIds = row.packages_id.split(',');
                        // data[index][column.key] = packageIds.reduce((accumulator, currentValue) => accumulator + (currentValue.split('|')[0] === id ? 1 : 0), 0);
                        let latestDate = '';
                        packageIds.forEach((d) => {
                            if(d.split('|')[0] === id) {
                                if(d.split('|')[1]) {
                                    if(latestDate != '') {
                                        if(new Date(d.split('|')[1]) > new Date(latestDate)){
                                            latestDate = d.split('|')[1]
                                        }
                                    } else {
                                        const pattern2 = /^\d{1,2}\/\d{1,2}\/\d{4}$/;//Regex pattern for "9/14/2023" format
                                        const pattern3 = /^\d{4}-\d{2}-\d{2}$/;//Regex pattern for "9-14-2023" format
                                        if (pattern2.test(d.split('|')[1])) {
                                            //# 3079 Download Date Column fix(discuss with hari on hard code value check)
                                            if ((d.split('|')[1]) == '23/8/2023') {
                                                const [day, month, year] = d.split('|')[1].split('/');
                                                const formattedDate = `${month}/${day}/${year}`;
                                                latestDate = formattedDate
                                            }
                                            else{
                                                latestDate = d.split('|')[1];
                                            }
                                           
                                        }
                                        else if (pattern3.test(d.split('|')[1])) {//"2023-11-07" Here we are considering 11th Month, O7 Day
                                            const [year, month, day] = d.split('|')[1].split('-').map(item => parseInt(item.trim(), 10));
 
                                            const dateObject = new Date(year, month - 1, day);
                                            const months = dateObject.getMonth() + 1; // Months are 0-based in JavaScript Date object, so we add 1
                                            const days = dateObject.getDate();
                                            const years = dateObject.getFullYear();
                                            latestDate = `${months}/${days}/${years}`
                                        }
                                        else {
                                            const [year, month, day] = d.split('|')[1].split('.').map(item => parseInt(item.trim(), 10));
                                            const dateObject = new Date(year, month - 1, day);
                                            // latestDate = dateObject;
 
                                            const months = dateObject.getMonth() + 1; // Months are 0-based in JavaScript Date object, so we add 1
                                            const days = dateObject.getDate();
                                            const years = dateObject.getFullYear();
                                            latestDate = `${months}/${days}/${years}`
                                        }


                                        
                                        /* const pattern2 = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
                                        if (pattern2.test(d.split('|')[1])) {
                                            latestDate = d.split('|')[1];
                                        } else {
                                            const [year, month, day] = d.split('|')[1].split('.').map(item => parseInt(item.trim(), 10));
                                            const dateObject = new Date(year, month - 1, day);
                                            const months = dateObject.getMonth() + 1; // Months are 0-based in JavaScript Date object, so we add 1
                                            const days = dateObject.getDate();
                                            const years = dateObject.getFullYear();
                                            latestDate = `${months}/${days}/${years}`
                                        } */
                                    }
                                }
                            }
                        });
                        data[index][column.key] = latestDate;
                    } else {
                        data[index][column.key] = '';
                    }
                    return;
                }
                data[index][column.key] = row[column.key];
            });
        });
        return data;
    }

    renderTable(columns, data, loading) {
        const totalDownloads = data.reduce(
          (sum, item) => sum + (item.DOWNLOADS || 0),
          0
        );



        const message = loading ? 'Loading data...' : 'No data available';
        return (
          <React.Fragment>
            {data.length ? (
              <table className="table">
                <thead>
                  <tr>
                    {columns.map((col, index) => {
                      return (
                        <th
                         className={`th head border_top ${index === 0 ? "border_left" : ""} ${col.key === "LAST_DOWNLOADED" ? "last_downloaded" : ""}`}
                          key={col.key}
                        >
                          {col.sort ? (
                            <React.Fragment>
                              {col.label}
                              <div
                                className={`sort-icon ${
                                  col.sort !== "default" ? "active" : ""
                                }`}
                                onClick={() => this.sortTable(col.key)}
                              >
                                <Icon
                                  svg={
                                    col.sort === "asc"
                                      ? svgSortAsc
                                      : col.sort === "desc"
                                      ? svgSortDesc
                                      : svgSort
                                  }
                                />
                              </div>
                            </React.Fragment>
                          ) : (
                            col.label
                          )}
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {data.map((row, index) => {
                    return (
                      <tr key={index}>
                        {columns.map((col, colIndex) => {
                          return (
                            <td
                              className={`td ${
                                colIndex === 0 ? "border_left" : ""
                              }`}
                              key={`${index}-${colIndex}`}
                              style={{ textAlign: col.style ? col.style : "" }}
                            >
                              {col.key === "email" ? (
                                <a
                                  href={`mailto:${
                                    row[col.key] ? row[col.key] : ""
                                  }`}
                                >
                                  {row[col.key]}
                                </a>
                              ) : (
                                row[col.key]
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
             <tr>
  {columns.map((col, colIndex) => {
    if (col.key === "DOWNLOADS") {
      return (
        <td
          key={`footer-${colIndex}`}
          style={{
            textAlign: col.align || "center",
            width: col.width || "auto",
            fontWeight: "bold"
          }}
        >
          Total Downloads : {totalDownloads}
        </td>
      );
    }
    return <td key={`footer-${colIndex}`} />;
  })}
</tr>


                </tbody>
              </table>
            ) : (
              <div className="no-data-found">{message}</div>
            )}
          </React.Fragment>
        );
    }

    render() {
        const {columns, data, loading, propertyInfo} = this.state;

        return (
            <ApolloConsumer>
            {
                client => {
                    if (!this.client) {
                        this.client = client;
                    }
                    return (
            <div className='property-statistics-container'>
                <h4 className='property-info'>{propertyInfo}</h4>
                {this.renderTable(columns, data, loading)}
            </div>
 )
}
}
</ApolloConsumer>
        )
    }
}